import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoDotsHorizontal16 = t0 => {
  const $ = _c(12);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M8.00016 8.66668C8.36836 8.66668 8.66683 8.36821 8.66683 8.00001C8.66683 7.63181 8.36836 7.33334 8.00016 7.33334C7.63196 7.33334 7.3335 7.63181 7.3335 8.00001C7.3335 8.36821 7.63196 8.66668 8.00016 8.66668Z" />;
    t3 = <path d="M12.0002 8.66668C12.3684 8.66668 12.6668 8.36821 12.6668 8.00001C12.6668 7.63181 12.3684 7.33334 12.0002 7.33334C11.632 7.33334 11.3335 7.63181 11.3335 8.00001C11.3335 8.36821 11.632 8.66668 12.0002 8.66668Z" />;
    t4 = <path d="M4.00016 8.66668C4.36835 8.66668 4.66683 8.36821 4.66683 8.00001C4.66683 7.63181 4.36835 7.33334 4.00016 7.33334C3.63198 7.33334 3.3335 7.63181 3.3335 8.00001C3.3335 8.36821 3.63198 8.66668 4.00016 8.66668Z" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== iconColor) {
    t5 = <g stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">{t2}{t3}{t4}</g>;
    $[5] = iconColor;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <defs />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== ariaLabel || $[9] !== className || $[10] !== t5) {
    t7 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t5}{t6}</svg>;
    $[8] = ariaLabel;
    $[9] = className;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default IcoDotsHorizontal16;